"use client";
import React from "react";

export default function Page() {
    return (
        <div>
            <h1>Page</h1>
        </div>
    );
}
